'use strict';

angular.module('AcaApp').factory('AuxiliaryOperationsResource', [
  '$resource',
  function($resource){
    return $resource(
      '/api/auxOp',
      {},
      {
        executeRpc: {
          method: 'POST',
          isArray: false
        }
      }
    );
  }
]);
